import { Icon, IconProps } from "@chakra-ui/react";
import React from "react";

export function SiUserProfile(props: IconProps): React.ReactElement {
  return (
    <Icon viewBox="0 0 24 24" fill="none" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M20.5 21c0-1.396 0-2.093-.172-2.661a4 4 0 0 0-2.667-2.667C17.093 15.5 16.396 15.5 15 15.5h-5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C4.5 18.907 4.5 19.604 4.5 21M17 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
      />
    </Icon>
  );
}
